import { showToast } from '../Components/ToastNotifications';

// Jaring pengaman: BANYAK halaman (mis. AdminUsersList.jsx) memanggil API di
// dalam useEffect TANPA try/catch sama sekali. Ketika request ditolak (403
// RBAC, 401, error jaringan, dst), Promise-nya reject dan tidak pernah
// ditangkap -> browser memicu event 'unhandledrejection'. Tanpa handler ini,
// user tidak melihat apa pun selain layar kosong/loading macet (di produksi)
// atau overlay merah react-error-overlay (di development).
//
// INI JARING PENGAMAN, BUKAN PENGGANTI try/catch yang benar per halaman --
// menampilkan toast di sini tidak menghentikan overlay dev-mode CRA (yang
// punya listener unhandledrejection sendiri, independen dari preventDefault
// di sini). Halaman yang paling sering kena (list page tanpa try/catch)
// sebaiknya tetap diperbaiki satu per satu untuk pengalaman yang bersih.
export function registerGlobalErrorHandler() {
  window.addEventListener('unhandledrejection', (event) => {
    const message = event.reason?.message;
    if (typeof message === 'string' && message.trim()) {
      showToast(message, 'danger');
    } else {
      showToast('Terjadi kesalahan tak terduga. Silakan coba lagi.', 'danger');
    }
    event.preventDefault();
  });
}
